<template>
	<div :class="{ 'hide': isHide }" class="footer qjc-clearfix qjc-fixed">
		<van-image
			@click="$router.back()"
			class="qjc-fl"
			width="25%"
			height="0.98rem"
			:src="require('@/assets/images/m_back.png')"
		></van-image>
		<van-image
			@click="$router.push($route.fullPath.split('/m')[0] + '/m')"
			class="qjc-fl"
			width="25%"
			height="0.98rem"
			:src="require('@/assets/images/m_gohome.png')"
		></van-image>
		<van-image
			@click="$router.go(0)"
			class="qjc-fl"
			width="25%"
			height="0.98rem"
			:src="require('@/assets/images/m_reload.png')"
		></van-image>
		<van-image
			@click="$router.go(1)"
			class="qjc-fl"
			width="25%"
			height="0.98rem"
			:src="require('@/assets/images/m_advans.png')"
		></van-image>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Image } from 'vant'
	Vue.use(Image);
	
	export default{
		name: 'mFooter',
		data() {
			return {
				touchY: 0,// 触摸位置，用来判断上滑还是下滑
				
				isHide: false// 底部导航是否收起
			}
		},
		mounted() {
			window.addEventListener('touchmove', this.slide);
		},
		methods: {
			slide(e) {
				let eTouchY = e.changedTouches[0].clientY;
				
				if(eTouchY > this.touchY){
					this.isHide = true;
				}else{
					this.isHide = false;
				}
				
				this.touchY = eTouchY;
			}
		},
		destroyed() {
			window.removeEventListener('touchmove', this.slide);
		}
	}
</script>

<style lang="scss" scoped>
	.footer{
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,.6);
		transition: all .5s;
		
		&.hide{
			bottom: -1rem;
		}
		
	}
</style>
